import api from "./api";

class ReportService {
    // ── Project Reports ──────────────────────────────────────────────────────

    listProjectReports(params = {}) {
        return api.get("/api/project-reports/", { params });
    }

    getProjectReport(id) {
        return api.get(`/api/project-reports/${id}/`);
    }

    createProjectReport(data) {
        return api.post("/api/project-reports/", data);
    }

    updateProjectReport(id, data) {
        return api.patch(`/api/project-reports/${id}/`, data);
    }

    deleteProjectReport(id) {
        return api.delete(`/api/project-reports/${id}/`);
    }

    // ── Attachments (DropBox) ────────────────────────────────────────────────

    uploadDocument(file) {
        const formData = new FormData();
        formData.append("document", file);
        formData.append("title", file.name);
        return api.post("/api/reports/dropbox/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    }

    deleteDocument(id) {
        return api.delete(`/api/reports/dropbox/${id}/`);
    }

    // ── Door Service Reports ─────────────────────────────────────────────────

    listDoorServiceReports(params = {}) {
        return api.get("/api/door-service-reports/", { params });
    }

    getDoorServiceReport(id) {
        return api.get(`/api/door-service-reports/${id}/`);
    }

    createDoorServiceReport(data) {
        return api.post("/api/door-service-reports/", data);
    }

    updateDoorServiceReport(id, data) {
        return api.patch(`/api/door-service-reports/${id}/`, data);
    }

    deleteDoorServiceReport(id) {
        return api.delete(`/api/door-service-reports/${id}/`);
    }

    // ── Incident Reports ─────────────────────────────────────────────────────

    listIncidentReports(params = {}) {
        return api.get("/api/incident-reports/", { params });
    }

    getIncidentReport(id) {
        return api.get(`/api/incident-reports/${id}/`);
    }

    createIncidentReport(data) {
        return api.post("/api/incident-reports/", data);
    }

    updateIncidentReport(id, data) {
        return api.patch(`/api/incident-reports/${id}/`, data);
    }

    deleteIncidentReport(id) {
        return api.delete(`/api/incident-reports/${id}/`);
    }

    // ── RF Test Reports ──────────────────────────────────────────────────────

    listRFTestReports(params = {}) {
        return api.get("/api/rf-test-reports/", { params });
    }

    getRFTestReport(id) {
        return api.get(`/api/rf-test-reports/${id}/`);
    }

    createRFTestReport(data) {
        return api.post("/api/rf-test-reports/", data);
    }

    updateRFTestReport(id, data) {
        return api.patch(`/api/rf-test-reports/${id}/`, data);
    }

    deleteRFTestReport(id) {
        return api.delete(`/api/rf-test-reports/${id}/`);
    }
}

export default new ReportService();
